const BASKET_TYPES = {
    PREBASKET: 'prebasket',
    DC_BASKET: 'distribution center basket',
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket',
    SAMEDAY_BASKET: 'SameDay',
    STANDARD_BASKET: 'ShipToHome'
};

const ROOT_BASKET_TYPES = {
    PRE_BASKET: 'PRE_BASKET',
    MAIN_BASKET: 'MAIN_BASKET'
};

const MAIN_BASKET_TYPES = {
    DC_BASKET: 'distribution center basket',
    BOPIS_BASKET: 'buy online and pick up basket'
};

const BOPIS_TYPES = {
    ROPIS_BASKET: 'reserve and pick up basket',
    BOPIS_BASKET: 'buy online and pick up basket'
};

const SAMEDAY_TYPES = {
    SDU: 'SDU'
};

const CART_SECTION_BANNERS = {
    SDD_ROUGE_INSENTIVE_BANNER: 'SameDay ROUGE Member promo insentive banner'
};

const DC_BASKET_TYPES = {
    SAMEDAY_BASKET: 'SameDay',
    STANDARD_BASKET: 'ShipToHome',
    AUTOREPLENISH_BASKET: 'Autoreplenish'
};

module.exports = {
    BASKET_TYPES,
    ROOT_BASKET_TYPES,
    MAIN_BASKET_TYPES,
    BOPIS_TYPES,
    DC_BASKET_TYPES,
    SAMEDAY_TYPES,
    CART_SECTION_BANNERS
};
